import z from "zod";

/*
 * Сначала захотели, чтобы дефолтная дата могла быть указана несколькими способами:
 *  (1) Отсутствует
 *  (2) Дата создания класса/записи
 *  (3) Указать дату вручную
 * Поэтому появился тип ZDateDefault с соответствующими вариантами zRelative(2) и zAbsolute(3).
 * Потом оказалось, что на фронте невозможно указать дату создания, т.к. карточка для нового объекта
 * выводится пользователю до того как создан объект.
 * Задачу можно было бы решить на бэке, если бы они читали метаданные и выполняли соответтствующее заполнение
 * в момент создания объекта (т.к. сейчас такое значение есть в системном поле createdAt).
 * Но никто этим заниматься не захотел. Сочли что проще убрать вариант (2) zRelative
 * Поэтому сейчас в настройках вместо радиогруппы просто DatePicker.
 * Если он пуст, то это (1). Если заполнен - это (3)
 * То есть, можно было бы убрать весь тип ZDateDefault и заменить его на string.
 *
 * Но я оставляю его для совместимости с имеющимися данными.
 * А так же из личного опыта могу предсказать, что абсолютная дата абсолютно бесполезна в качестве дефолтного значения 😁
 * Потому что если например указать дату из следующего года, то через год она уже будет из прошлого года.
 * Вряд ли кто-то захочет регулярно лазить в админку и подправлять там эту дефолтную дату.
 * Намного полезнее было бы в качестве дефолтной даты использовать смещение относительно сегодня.
 * Например, +2 недели.
 * Подробнее см. тут: https://day.js.org/docs/en/manipulate/manipulate
 * Если это всё-таки потребуется, тогда можно будет дополнить zRelative параметрами для указания смещения относительной даты
 * Либо расширить количество вариантов для более специфических ситуаций.
 */

const zRelative = z.object({
  type: z
    .literal("relative")
    .describe("Будет использована дата создания класса/записи"),
});

const zAbsolute = z.object({
  type: z.literal("absolute").describe("Дата указывается в явном виде"),
  value: z.string().describe("Дата по умолчанию"),
});

export const zDateDefault = z.discriminatedUnion("type", [
  zRelative,
  zAbsolute,
]);
export type ZDateDefault = z.infer<typeof zDateDefault>;
